// extracted by mini-css-extract-plugin
export var brand = "_15-8";
export var compact = "_15-5";
export var extraSmall = "_15-6";
export var icon = "_15-0";
export var large = "_15-3";
export var light = "_15-1";
export var medium = "_15-4";
export var outline = "_15-a";
export var primaryDark = "_15-9";
export var primaryLight = "_15-7";
export var primaryModern = "_15-b";
export var success = "_15-2";